import React, { FC, useState } from 'react';

import { DescriptionItem } from './DescriptionItem';

export const ProductDescription: FC<{
  currentDesktopTab: string;
  data: {
    mobileInitiallyOpen: boolean;
    text: React.ReactNode | string;
    title: string;
  }[];
  gridArea: string;
}> = ({ currentDesktopTab, data, gridArea }) => {
  const initialMobileVisibility: Record<string, boolean> = {};
  data.forEach(({ mobileInitiallyOpen, title }) => {
    initialMobileVisibility[title] = mobileInitiallyOpen;
  });
  const [mobilePiecesVisibility, setMobilePiecesVisibility] = useState(initialMobileVisibility);

  return (
    <div className="product-description">
      {data.map(({ text, title }) => (
        <DescriptionItem
          descriptionNode={text}
          desktopVisible={title === currentDesktopTab}
          mobileVisible={!!mobilePiecesVisibility[title]}
          onMobileClick={() => {
            setMobilePiecesVisibility({
              ...mobilePiecesVisibility,
              [title]: !mobilePiecesVisibility[title],
            });
          }}
          title={title}
        />
      ))}
      <style jsx>{`
        .product-description {
          grid-area: ${gridArea};
        }
      `}</style>
    </div>
  );
};
